import { useTranslation } from 'react-i18next';
import { useData } from 'vike-react/useData';

import { Text } from '../../components/ui/text';
import type { PageData } from './+data';
import { SongsTable } from './components/SongsTable';
import { Metadata } from '~/components/layout/Metadata';
import { Stack } from 'styled-system/jsx';

export function Page() {
  const { t } = useTranslation();
  const data: PageData = useData();
  const title = t('title');

  return (
    <>
      <Metadata title={title} />
      <Stack alignItems="center" w="full" _print={{ display: 'none' }}>
        <Text textAlign="center" fontSize="3xl" fontWeight="bold">
          {title}
        </Text>
        <Text textAlign="center">{t('description')}</Text>
        <SongsTable songs={data.songs} />
      </Stack>
    </>
  );
}
